import { useState, useRef, useContext } from 'react';
import { Box, Grid, Typography } from '@mui/material';

import {
  Button as CustomButton,
  DataLoading,
} from '../../../components/common';
import colors from '../../../assets/colors';
import { directPayment } from '../../../utils/api';
import FarmContext from '../../../store/farm-context';

export default function DirectPaymentFileUploader({ update, changeYear }) {
  const hiddenFileInput = useRef(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState(false);
  const [uploadErrorMessage, setUploadErrorMessage] = useState();
  const farmCTX = useContext(FarmContext);

  const handleInputClick = (event) => {
    hiddenFileInput.current.click();
  };

  const onChangeHandler = async (event) => {
    await uploadFile(event.target.files[0]);
  };

  const uploadFile = (fileup) => {
    setIsUploading(true);
    const data = new FormData();
    data.append('file', fileup);
    directPayment
      .add(farmCTX.farmID, data)
      .then((result) => {
        update();
        setIsUploading(false);
        changeYear(result.data);
      })
      .catch((err) => {
        setUploadError(true);
        setUploadErrorMessage(err.response.data);
      });
  };

  return isUploading ? (
    uploadError ? (
      <Box component="div" sx={{ marginTop: 10 }}>
        <Typography
          variant="h4"
          component="h1"
          align="center"
          sx={{ color: colors.redError }}
        >
          Podczas analizy wniosku wystąpił błąd.
        </Typography>
        <Typography
          variant="h6"
          component="h1"
          align="center"
          sx={{ color: colors.redError }}
        >
          {uploadErrorMessage}
        </Typography>
        <Typography
          variant="h6"
          component="h1"
          align="center"
          sx={{ color: colors.redError }}
        >
          By kontynuować odśwież stronę.
        </Typography>
      </Box>
    ) : (
      <Box component="div" sx={{ marginTop: 10 }}>
        <DataLoading />
        <Typography
          variant="h4"
          component="h1"
          align="center"
          sx={{ color: colors.oldAgroweGreen }}
        >
          Trwa analizowanie wniosku. Prosimy o cierpliwość.
        </Typography>
      </Box>
    )
  ) : (
    <Box
      component={Grid}
      container
      sx={{ marginTop: 10 }}
      alignItems="center"
      justifyContent="center"
    >
      <CustomButton
        type="submit"
        variant="contained"
        sx={{ minHeight: '30vh', fontSize: 32, width: '75%' }}
        onClick={handleInputClick}
      >
        Umieść wniosek o dopłaty aby obliczyć dochód i strukturę płodozmianu
      </CustomButton>
      <input
        ref={hiddenFileInput}
        style={{ display: 'none' }}
        id="file"
        type="file"
        name="file"
        onChange={onChangeHandler}
        data-testid="fileInput"
      />
    </Box>
  );
}
